const Modal = ({ children }) => {
  return (
    <div className="modal">
      <section className="modal-main">{children}</section>
    </div>
  );
};
export default Modal;
